module.exports = __webpack_public_path__ + "img/building.c4c74696.svg";